import { render, staticRenderFns } from "./dropdownMenu.vue?vue&type=template&id=08ad722a&"
import script from "./dropdownMenu.vue?vue&type=script&lang=ts&"
export * from "./dropdownMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports